import dynamic from "next/dynamic";

export const DynamicHero014 = dynamic(() => import("./Hero014"), {
  suspense: true,
});
